export const stagesSelectionProcess = [
  { label: 'Análise de currículo', value: 'Análise de currículo' },
  { label: 'Entrevista com RH', value: 'Entrevista com RH' },
  {
    label: 'Testes de competências e habilidades',
    value: 'Testes de competências e habilidades',
  },
  { label: 'Entrevista técnica', value: 'Entrevista técnica' },
  { label: 'Entrevista com gestor', value: 'Entrevista com gestor' },
];
